import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const SlouchyLongTee = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.SlouchyLongTee.itemName}
      name={AW23.tops.SlouchyLongTee.itemName}
      price={AW23.tops.SlouchyLongTee.itemPrice}
      fabric={AW23.tops.SlouchyLongTee.itemFabric}
      src={AW23.tops.SlouchyLongTee.sizeChart}
      divId={AW23.tops.SlouchyLongTee.shopifyDivId}
      mainId={AW23.tops.SlouchyLongTee.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.SlouchyLongTee.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.SlouchyLongTee.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default SlouchyLongTee;
